import moment from "moment";
import React, { useEffect, useState } from "react";
import { Container, Modal } from "react-bootstrap";
import Flatpickr from "react-flatpickr";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import {
  allocateVol,
  fetchMasterOnClientLocation,
} from "../../../services/managerService";
import "../ManagerWorklistDetails.css";
import DateRangePicker from "react-bootstrap-daterangepicker";

const WatchListBodyAddVol = ({ masterData, changeParentList, onQuery }) => {
  const [showModalBox, setShowModalBox] = useState(false);
  const [selectClientId, setSelectClientId] = useState();
  const [selectLocationId, setSelectLocationId] = useState();
  const [selectSpecialtyId, setSelectSpecialtyId] = useState();
  const [isDisabled, setIsDisabled] = useState(true);
  const navigate = useNavigate();
  const [isLoading, setLoadingState] = useState(false);
  const [isRecevingDateTodayFlag, setRecevingDateTodayFlag] = useState(true);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [submissionType, setSubmissionType] = useState(null);
  const [receivedDate, setReceivedDate] = useState();
  const [dateOfService, setDateOfSerice] = useState(null);
  const [isAstriaLocation, setAstriaLocationFlag] = useState(false);
  const [showPreviewModalBox, setShowPreviewModalBox] = useState(false);
  const [astriaChartUploadType, setAstriaChartUploadType] = useState();
  const [isDnfbPreviewComplete, setDnfbPreviewState] = useState(false);
  const [processList, setProcessList] = useState([]);
  const [processDisable, setProcessDisable] = useState(true);

  const options = {
    maxDate: new Date(),
    dateFormat: "m/d/Y",
  };

  options.maxDate.setDate(options.maxDate.getDate() + 1);

  const optionsDS = {
    mode: "multiple",
    maxDate: new Date(),
    dateFormat: "m/d/Y",
  };

  const {
    register,
    handleSubmit,
    control,
    getValues,
    formState: { errors },
    reset,
    setValue,
  } = useForm();

  const registerOptions = {
    worklist_no: {
      pattern: { value: /^\S/, message: "Invalid input" },
    },
    ClientId: { required: "Required" },
    no_of_charts: {
      pattern: { value: /^-?\d+$/, message: "Invalid input" },
      max: { value: 99999, message: "Exceeded max limit" },
      min: { value: 1, message: "Invalid input" },
    },
    ProcessId: { required: "Required" },
    LocationId: { required: "Required" },
    date_of_service: {},
    SpecialtyId: { required: "Required" },
    received_date: { required: "Required" },
    WorklistData: {},
  };

  function isCurrentTimePastFiveThirtyAmMark() {
    let currentTimestamp = Date.now();

    let fiveAMTimestamp = new Date();
    fiveAMTimestamp.setHours(5, 0, 0, 0);
    fiveAMTimestamp.setMinutes(fiveAMTimestamp.getMinutes() + 30);
    return currentTimestamp >= fiveAMTimestamp.getTime();
  }

  const validateIfInvalidDateWorklistIsBeingCreated = (received_date) => {
    const today = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);

    const receivedDate = moment(received_date);

    const isRecevingDateForTomorrow =
      receivedDate.date() === tomorrow.getDate() &&
      receivedDate.month() === tomorrow.getMonth() &&
      receivedDate.year() === tomorrow.getFullYear();

    if (isRecevingDateForTomorrow && !isCurrentTimePastFiveThirtyAmMark()) {
      window.toastr.error(
        "Please try after 5:30 am IST to add this future dated worklist.",
      );

      throw new Error(
        "Please try after 5:30 am IST to add this future dated worklist.",
      );
    }
  };

  const handleSubmitPreview = async (type, dateConfirm = false) => {
    await handleSubmit((data) => {
      setLoadingState(true);
      const { WorklistData, ExcelData, no_of_charts, ...postData } = data;

      validateIfInvalidDateWorklistIsBeingCreated(data.received_date);

      const isExcelUpload = !!ExcelData?.length;

      if (!isRecevingDateTodayFlag && !dateConfirm) {
        setSubmissionType(type);
        setLoadingState(false);
        return setShowConfirmationModal(true);
      }

      // console.log({ isExcelUpload, isAstriaLocation });

      if (isExcelUpload && !isAstriaLocation) {
        ExcelData.shift();
      }

      let finalData = isExcelUpload ? ExcelData : undefined;
      // console.log(
      //   isAstriaLocation,
      //   astriaChartUploadType === "DNFB",
      //   isExcelUpload,
      // );
      if (
        isAstriaLocation &&
        astriaChartUploadType === "DNFB" &&
        isExcelUpload
      ) {
        // console.log("here??", ExcelData);
        finalData = ExcelData.filter((item) => item.isIncluded).map((item) => {
          return [
            item.chart_no,
            item.mr_no,
            item.date_of_service,
            item.admit_date,
            item.discharge_date,
            item.facility,
          ];
        });
      }

      // console.log({ finalData });

      const payload = {
        ...postData,
        date_of_service: isExcelUpload ? undefined : dateOfService,
        no_of_charts: isExcelUpload ? undefined : no_of_charts,
        ExcelData: finalData && finalData?.length ? finalData : undefined,
      };

      allocateVol(payload)
        .then((data) => {
          if (data?.success === true) {
            if (type !== "allocate") {
              window.toastr.success("Worklist volume added successfully");
            }
            changeParentList(true);
            setShowModalBox(false);
            onQuery(data);
            reset({
              worklist_no: "",
              no_of_charts: "",
              LocationId: "",
              SpecialtyId: "",
              ClientId: "",
              ProcessId: "",
              WorklistData: "",
            });
            setReceivedDate(null);
            setProcessList([]);
            setProcessDisable(true);
            setDateOfSerice(null);
            setRecevingDateTodayFlag(false);
            if (type === "allocate") {
              navigate("/manager-worklist-details", {
                state: { worklist_id: data?.data?.id },
              });
            }
          } else {
            const errorMsg = data?.error?.[0]?.message || data?.message;
            window.toastr.error(errorMsg);
          }
          setLoadingState(false);
        })
        .catch((error) => {
          const errorMsg = error?.[0]?.message || error.message;
          window.toastr.error(errorMsg);
          setLoadingState(false);
        });
    })();
  };

  const handleClientChange = async (event) => {
    const selectedClient = event.target.value;
    setSelectClientId(selectedClient);
    setValue("ClientId", selectedClient);
    if (selectedClient !== "") {
      await fetchClientLocationMaster(selectedClient, "");
    }

    // Update the form value
    if (errors.ClientId) {
      setValue("ClientId", selectedClient, { shouldValidate: true });
    }
    if (selectedClient === "") {
      reset({
        LocationId: "",
        SpecialtyId: "",
      });
      setIsDisabled(true);
    }
  };

  const handleLocationChange = async (event) => {
    await fetchClientLocationMaster(selectClientId, event.target.value);
    setValue("LocationId", event.target.value);

    const locations = masterData?.locations;
    const selectedLocation = locations?.find(
      (location) => location.id === parseInt(event.target.value, 10),
    );

    if (selectedLocation?.name.toLowerCase() === "astria") {
      setAstriaLocationFlag(true);
      setAstriaChartUploadType(undefined);
    } else {
      setAstriaChartUploadType(null);
      setAstriaLocationFlag(false);
    }

    if (errors.LocationId) {
      setValue("LocationId", event.target.value, { shouldValidate: true });
    }
  };

  const handleAstriaChartUploadTypeChange = (event) => {
    if (event.target.value === "null") {
      setAstriaChartUploadType(null);
      return;
    }
    setAstriaChartUploadType(event.target.value);
  };

  const fetchClientLocationMaster = async (cID, lID) => {
    const response = await fetchMasterOnClientLocation(cID, lID);
    setSelectLocationId(response?.locations);
    setSelectSpecialtyId(response?.specialties);
    if (cID && lID) {
      setProcessList(response?.processes);
      setProcessDisable(false);
    } else {
      setProcessList([]);
      setProcessDisable(true);
    }
    setIsDisabled(false);
  };

  const handleEventDateOfService = (event, picker) => {
    picker.element.val(
      picker.startDate.format("MM/DD/YYYY") +
      " - " +
      picker.endDate.format("MM/DD/YYYY"),
    );
    setDateOfSerice(
      picker.startDate.format("MM/DD/YYYY") +
      " - " +
      picker.endDate.format("MM/DD/YYYY"),
    );
  };
  const handleCancelDateOfService = (event, picker) => {
    picker.element.val("");
    setDateOfSerice("");
  };

  useEffect(() => { }, [selectLocationId, selectSpecialtyId]);

  const handleFileUpload = async (e) => {
    try {
      const file = e.target.files[0];
      const data = await file.arrayBuffer();
      const workbook = XLSX.read(data);
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, {
        header: 1,
        defval: "",
        raw: false,
      });
      setValue("ExcelData", jsonData);
    } catch (error) {
      console.log(error);
    }
  };

  const handlePreview = async (e) => {
    setShowModalBox(false);
    setShowPreviewModalBox(true);
  };

  useEffect(() => {
    if (showPreviewModalBox) {
      setChartData();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showPreviewModalBox]);

  function identifyChartsToExclude() {
    const updatedCharts = [];
    const facilities = masterData?.facility;
    const excelData = getValues("ExcelData");
    const locationId = getValues("LocationId");
    let counter = 0;

    const astriaFacilities = facilities?.filter(
      (facility) => facility.LocationId === parseInt(locationId, 10),
    );

    // Remove the first row with headers data
    if (excelData?.length) {
      excelData.shift();
    }

    if (excelData?.length && astriaFacilities?.length) {
      excelData.forEach((item) => {
        const facility = astriaFacilities.find(
          (facility) => facility.name === item[5],
        );

        if (!facility) {
          counter++;
          updatedCharts.push({
            chart_no: item[0],
            mr_no: item[1],
            date_of_service: item[2],
            admit_date: item[3],
            discharge_date: item[4],
            facility: item[5],
            isIncluded: false,
          });
        } else {
          updatedCharts.push({
            chart_no: item[0],
            mr_no: item[1],
            date_of_service: item[2],
            admit_date: item[3],
            discharge_date: item[4],
            facility: item[5],
            isIncluded: true,
          });
        }
      });
    }

    return { counter, updatedCharts };
  }

  const emptyRow = () => (
    <tr key={1}>
      <td></td>
      <td></td>
      <td></td>
      <td>No charts will be excluded</td>
      <td></td>
      <td></td>
      <td></td>
    </tr>
  );

  function rowClassName(isIncluded) {
    return isIncluded ? "align-middle table-success" : "align-middle";
  }

  const [chartsToBeRemoved, updateChartCount] = useState(0);
  const [updatedCharts, updateChartData] = useState([]);

  function setChartData() {
    const { updatedCharts, counter } = identifyChartsToExclude();
    updateChartData(updatedCharts);
    updateChartCount(counter);
  }

  function renderChartsForEvaluation() {

    if (!updatedCharts?.length) {
      return emptyRow;
    }

    return updatedCharts.map((item, index) => {
      return (
        <tr key={index} className={rowClassName(item.isIncluded)}>
          <td>{item.chart_no}</td>
          <td>{item.mr_no}</td>
          <td>{item.date_of_service}</td>
          <td>{item.admit_date}</td>
          <td>{item.discharge_date}</td>
          <td>{item.facility}</td>
        </tr>
      );
    });
  }

  const getChartCountData = () => {
    return chartsToBeRemoved;
  };

  const onModalHide = () => {
    setIsDisabled(true);
    setShowModalBox(false);
    reset({
      keepErrors: false,
      worklist_no: "",
      no_of_charts: "",
      LocationId: "",
      SpecialtyId: "",
      ClientId: "",
      ProcessId: "",
    });
    setProcessList([]);
    setProcessDisable(true);
    setLoadingState(false);
    setReceivedDate("");
  };

  return (
    <>
      <div
        className="d-flex justify-content-end"
        data-kt-user-table-toolbar="base"
      >
        <button
          type="button"
          className="btn btn-primary"
          onClick={(e) => {
            setShowModalBox(true);
          }}
        >
          <span className="svg-icon svg-icon-2">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                opacity="0.5"
                x="11.364"
                y="20.364"
                width="16"
                height="2"
                rx="1"
                transform="rotate(-90 11.364 20.364)"
                fill="currentColor"
              />
              <rect
                x="4.36396"
                y="11.364"
                width="16"
                height="2"
                rx="1"
                fill="currentColor"
              />
            </svg>
          </span>
          Add Volume
        </button>
      </div>
      <Container>
        <Modal show={showModalBox} size="lg" centered onHide={onModalHide}>
          <div>
            <div>
              <Modal.Header className="modal-header py-4">
                <h2 className="fw-bold">Add Volume</h2>
                <Modal.Title
                  className="btn btn-icon btn-sm btn-active-icon-primary"
                  onClick={(e) => {
                    setIsDisabled(true);
                    setShowModalBox(false);
                    reset({
                      keepErrors: false,
                      worklist_no: "",
                      no_of_charts: "",
                      LocationId: "",
                      SpecialtyId: "",
                      ClientId: "",
                      ProcessId: "",
                    });
                    setProcessList([]);
                    setProcessDisable(true);
                    setLoadingState(false);
                  }}
                >
                  <span className="svg-icon svg-icon-1">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        opacity="0.5"
                        x="6"
                        y="17.3137"
                        width="16"
                        height="2"
                        rx="1"
                        transform="rotate(-45 6 17.3137)"
                        fill="currentColor"
                      />
                      <rect
                        x="7.41422"
                        y="6"
                        width="16"
                        height="2"
                        rx="1"
                        transform="rotate(45 7.41422 6)"
                        fill="currentColor"
                      />
                    </svg>
                  </span>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body className="modal-body scroll-y">
                <form>
                  <div className="row mb-2">
                    <div className="col-6">
                      <label className="form-label">Worklist #</label>
                      <input
                        className="form-control"
                        type="text"
                        name="worklist_no"
                        placeholder=""
                        {...register(
                          "worklist_no",
                          registerOptions.worklist_no,
                        )}
                      />
                      <small className="text-danger">
                        {errors?.worklist_no && errors.worklist_no.message}
                      </small>
                    </div>
                    <div className="col-6">
                      <label className="fs-6 fw-semibold mb-2">
                        <span>Received Date</span>
                      </label>
                      <Controller
                        name="received_date"
                        control={control}
                        defaultValue=""
                        render={({ field: { onChange, ...fieldProps } }) => (
                          <Flatpickr
                            options={options}
                            value={receivedDate}
                            onChange={(dates, currentdateString) => {
                              onChange(currentdateString);
                              const receivedDate = moment(currentdateString);
                              const today = moment();
                              const isRecevingDateToday =
                                receivedDate.date() === today.date() &&
                                receivedDate.month() === today.month() &&
                                receivedDate.year() === today.year();
                              setRecevingDateTodayFlag(isRecevingDateToday);
                              setReceivedDate(dates[0]);
                            }}
                            className="form-control col-lg-6"
                            placeholder=""
                            name="received_date"
                          />
                        )}
                        rules={{
                          required: "Required",
                          validate: () => {
                            const receivedDate = moment(
                              getValues("received_date"),
                            );

                            const lastDOS =
                              dateOfService && dateOfService.includes("-")
                                ? dateOfService.split(" - ")[1]
                                : dateOfService;
                            const dateOfServiceDate = moment(lastDOS);

                            if (!!dateOfServiceDate.toISOString()) {
                              return (
                                dateOfServiceDate <= receivedDate ||
                                "Received date should be equal to or greater than the Date of service"
                              );
                            }
                          },
                        }}
                      />
                      <small className="text-danger">
                        {errors?.received_date && errors.received_date.message}
                      </small>
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-6">
                      <label className="form-label">Client </label>
                      <select
                        className="form-select mb-2"
                        data-control="select2"
                        data-hide-search="true"
                        name="ClientId"
                        {...register("ClientId", registerOptions.ClientId)}
                        onChange={(e) => {
                          handleClientChange(e);
                        }}
                      >
                        <option value="">---</option>
                        {masterData?.clients?.map((option) => (
                          <option key={option.id} value={option.id}>
                            {option.name}
                          </option>
                        ))}
                      </select>
                      <small className="text-danger">
                        {errors?.ClientId && errors.ClientId.message}
                      </small>
                    </div>
                    <div className="col-6">
                      <label className="form-label">Location</label>
                      <select
                        className="form-select mb-2"
                        data-control="select2"
                        data-hide-search="true"
                        name="LocationId"
                        {...register("LocationId", registerOptions.LocationId)}
                        onChange={handleLocationChange}
                        disabled={isDisabled}
                      >
                        <option value="">---</option>
                        {selectLocationId?.map((option) => (
                          <option key={option.id} value={option.id}>
                            {option.name}
                          </option>
                        ))}
                      </select>
                      <small className="text-danger">
                        {errors?.LocationId && errors.LocationId.message}
                      </small>
                    </div>
                    <div className="col-6">
                      <label className="form-label">Process </label>
                      <select
                        className="form-select mb-2"
                        data-control="select2"
                        data-hide-search="true"
                        name="ProcessId"
                        {...register("ProcessId", registerOptions.ProcessId)}
                        disabled={processDisable}
                      >
                        <option value="">---</option>
                        {processList?.map((option) => (
                          <option key={option.id} value={option.id}>
                            {option.name}
                          </option>
                        ))}
                      </select>
                      <small className="text-danger">
                        {errors.ProcessId && errors.ProcessId.message}
                      </small>
                    </div>
                    <div className="col-6">
                      <label className="form-label">Primary Speciality </label>
                      <select
                        className="form-select mb-2"
                        data-hide-search="true"
                        name="SpecialtyId"
                        {...register(
                          "SpecialtyId",
                          registerOptions.SpecialtyId,
                        )}
                        disabled={isDisabled}
                      >
                        <option value="">---</option>
                        {selectSpecialtyId?.map((option) => (
                          <option key={option.id} value={option.id}>
                            {option.name}
                          </option>
                        ))}
                      </select>
                      <small className="text-danger">
                        {errors?.SpecialtyId && errors.SpecialtyId.message}
                      </small>
                    </div>
                  </div>

                  <hr></hr>

                  {getValues("LocationId") && (
                    <>
                      {isAstriaLocation && (
                        <div className="row mb-2">
                          <div className="col-6">
                            <label className="form-label">
                              Charts Upload Type
                            </label>
                            <select
                              className="form-select mb-2"
                              data-hide-search="true"
                              name="astria_chart_upload_type"
                              disabled={!isAstriaLocation}
                              onChange={handleAstriaChartUploadTypeChange}
                            >
                              <option value="null">------</option>
                              <option value="DNFB">DNFB Charts</option>
                              <option value="NON-DNFB">Non DNFB Charts</option>
                            </select>
                          </div>
                        </div>
                      )}

                      {(astriaChartUploadType === "NON-DNFB" ||
                        astriaChartUploadType === null) && (
                          <div className="row mb-2">
                            <div className="col-6">
                              <label className="fs-6 fw-semibold mb-2">
                                <span>Date of service</span>
                              </label>
                              <DateRangePicker
                                initialSettings={{
                                  autoUpdateInput: false,
                                  locale: { cancelLabel: "Clear" },
                                  showDropdowns: true,
                                  maxDate: optionsDS,
                                  drops: 'up'
                                }}
                                onApply={handleEventDateOfService}
                                onCancel={handleCancelDateOfService}
                              >
                                <input
                                  type="text"
                                  id="dateRangePickerDateOfService"
                                  className="form-control"
                                  placeholder="Select Date"
                                  defaultValue=""
                                  autoComplete="off"
                                />
                              </DateRangePicker>
                              <small className="text-danger">
                                {errors?.date_of_service &&
                                  errors.date_of_service.message}
                              </small>
                            </div>

                            <div className="col-6">
                              <label className="form-label">No. of Charts</label>
                              <input
                                className="form-control"
                                name="no_of_charts"
                                placeholder=""
                                {...register(
                                  "no_of_charts",
                                  registerOptions.no_of_charts,
                                )}
                              />
                              <small className="text-danger">
                                {errors?.no_of_charts &&
                                  errors.no_of_charts.message}
                              </small>
                            </div>
                          </div>
                        )}

                      {(astriaChartUploadType === "DNFB" ||
                        astriaChartUploadType === null) && (
                          <div className="row mb-2">
                            <div className="col-12">
                              <label className="form-label">Excel File </label>
                              <input
                                className="form-control"
                                name="WorklistData"
                                type="file"
                                accept=".csv, .xlx, .xlsx, .xlt"
                                placeholder=""
                                {...register(
                                  "WorklistData",
                                  registerOptions.WorklistData,
                                )}
                                onInput={handleFileUpload}
                              />
                              <small className="text-danger">
                                {errors?.WorklistData &&
                                  errors.WorklistData.message}
                              </small>
                              <div className="my-3">
                                <p>
                                  {getValues("ExcelData") ? (
                                    <small className="text-success fw-semibold">
                                      File already attached
                                    </small>
                                  ) : (
                                    ""
                                  )}
                                </p>
                                <p>
                                  <small className="text-muted">
                                    <i className="bi bi-info-circle"></i> To add a
                                    worklist without a file, please populate all
                                    fields. To add a worklist with a file, please
                                    populate all fields except date of service and
                                    no. of charts as they will not be considered.
                                  </small>
                                </p>
                              </div>
                            </div>
                          </div>
                        )}
                      <hr></hr>
                    </>
                  )}

                  <div className="text-center pt-3">
                    <button
                      type="reset"
                      className="btn btn-light me-3"
                      data-kt-users-modal-action="cancel"
                      onClick={(e) => {
                        setIsDisabled(true);
                        setShowModalBox(false);
                        reset({
                          keepErrors: false,
                          worklist_no: "",
                          no_of_charts: "",
                          LocationId: "",
                          SpecialtyId: "",
                          ClientId: "",
                          ProcessId: "",
                          WorklistData: null,
                        });
                      }}
                    >
                      Cancel
                    </button>

                    {isAstriaLocation && astriaChartUploadType === "DNFB" && (
                      <button
                        type="button"
                        className={`btn me-4 ${isLoading ? "btn-secondary" : "btn-primary"
                          }`}
                        onClick={(e) => handlePreview()}
                        disabled={!isAstriaLocation || isDnfbPreviewComplete}
                      >
                        <span className="indicator-label">
                          {isLoading ? "Please wait..." : "Preview"}
                        </span>
                      </button>
                    )}

                    <button
                      type="button"
                      className={`btn me-4 ${isLoading ? "btn-secondary" : "btn-primary"
                        }`}
                      onClick={(e) => handleSubmitPreview("save")}
                      disabled={
                        isLoading ||
                        (isAstriaLocation &&
                          astriaChartUploadType === "DNFB" &&
                          !isDnfbPreviewComplete)
                      }
                    >
                      <span className="indicator-label">
                        {isLoading ? "Please wait..." : "Save"}
                      </span>
                    </button>
                    <button
                      type="button"
                      className={`btn save-allocate-btn ${isLoading ? "btn-secondary" : "btn-primary"
                   }`}
                      onClick={(e) => handleSubmitPreview("allocate")}
                      disabled={
                        isLoading ||
                        (isAstriaLocation &&
                          astriaChartUploadType === "DNFB" &&
                          !isDnfbPreviewComplete)
                      }
                    >
                      <span className="indicator-label">
                        {isLoading ? "Please wait..." : "Save & Allocate"}
                      </span>
                    </button>
                  </div>
                </form>
              </Modal.Body>
            </div>
          </div>
        </Modal>
        <Modal
          show={showConfirmationModal}
          onHide={() => setShowConfirmationModal(false)}
        >
          <Modal.Header closeButton>
            <Modal.Title>Confirmation</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            The worklist you have created was not received today. Would you
            still like to proceed?
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn btn-secondary"
              onClick={() => {
                setShowConfirmationModal(false);
                setShowModalBox(false);
                reset({
                  worklist_no: "",
                  no_of_charts: "",
                  LocationId: "",
                  SpecialtyId: "",
                  ClientId: "",
                  ProcessId: "",
                  WorklistData: "",
                });
                setProcessList([]);
                setProcessDisable(true);
                setReceivedDate(null);
              }}
            >
              No
            </button>
            <button
              className="btn btn-primary"
              onClick={() => {
                handleSubmitPreview(submissionType, true);
                setShowConfirmationModal(false);
              }}
            >
              <span> {isLoading ? "Please wait..." : "Yes"}</span>
            </button>
          </Modal.Footer>
        </Modal>
      </Container>
      <Container>
        <Modal show={showPreviewModalBox} size="lg" centered>
          <div>
            <div>
              <Modal.Header className="modal-header py-4">
                <h2 className="fw-bold">Volume Preview</h2>
                <Modal.Title
                  className="btn btn-icon btn-sm btn-active-icon-primary"
                  onClick={(e) => {
                    setShowPreviewModalBox(false);
                    setShowModalBox(true);
                  }}
                >
                  <span className="svg-icon svg-icon-1">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        opacity="0.5"
                        x="6"
                        y="17.3137"
                        width="16"
                        height="2"
                        rx="1"
                        transform="rotate(-45 6 17.3137)"
                        fill="currentColor"
                      />
                      <rect
                        x="7.41422"
                        y="6"
                        width="16"
                        height="2"
                        rx="1"
                        transform="rotate(45 7.41422 6)"
                        fill="currentColor"
                      />
                    </svg>
                  </span>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body className="modal-body scroll-y my-5">
                {
                  <form>
                    <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                      <p style={{ fontWeight: 700 }}>
                        {getChartCountData()} chart/s have been removed because
                        these charts do not align to the facilities in scope.
                      </p>
                      <p>
                        Please see below the charts that will be included for
                        further processing, highlighted in green:
                      </p>
                      <table className="table align-middle table-row-dashed fs-5 gy-5 px-2">
                        <thead>
                          <tr className="text-start text-dark fw-bold fs-7 text-uppercase gs-0">
                            <th>Chart Number #</th>
                            <th>MRN</th>
                            <th>Date of Service</th>
                            <th>Admit Date</th>
                            <th>Discharge Date</th>
                            <th>Facility Name</th>
                          </tr>
                        </thead>
                        <tbody className="text-gray-600 fw-semibold w-100 align-middle text-center">
                          {renderChartsForEvaluation()}
                        </tbody>
                      </table>
                    </div>
                    <div className="row mb-4"></div>
                    <p style={{ fontWeight: 300 }}>
                      Note: At this point in time, charts that have already been
                      registered in other worklists have not been accounted for.
                      These will be identified and removed once you move to the
                      worklist chart allocation page.
                    </p>
                    <div className="text-center pt-8">
                      <button
                        type="reset"
                        className="btn btn-light me-3"
                        data-kt-users-modal-action="cancel"
                        onClick={(e) => {
                          setShowPreviewModalBox(false);
                          setShowModalBox(true);
                          setDnfbPreviewState(false);
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn btn-primary me-4"
                        disabled={isLoading}
                        onClick={(e) => {
                          e.preventDefault();
                          setValue("ExcelData", updatedCharts);
                          setShowPreviewModalBox(false);
                          setShowModalBox(true);
                          setDnfbPreviewState(true);
                        }}
                      >
                        <span className="indicator-label">
                          {isLoading ? "Please wait..." : "Proceed"}
                        </span>
                      </button>
                    </div>
                  </form>
                }
              </Modal.Body>
            </div>
          </div>
        </Modal>
      </Container>
    </>
  );
};

export default WatchListBodyAddVol;
